import * as M from '@mantine/core';

import { AI_AGENT_HISTORY_TYPE_LABELS } from '../../../../../../../shared/constants/typeOptions';
import { handleChangeLocaleTime } from '../../../../../../../shared/utils/time';

import type { IModelSettingHistoryItem } from '../../../../../../../shared/apis/ai-agent/model/types';
import type { ApiResponse } from '../../../../../../../shared/types/response/types';

interface IModelHistoryTableProps {
  data?: ApiResponse<IModelSettingHistoryItem>;
  page: number;
  size: number;
  isLoading: boolean;
  isError: boolean;
  onPageChange: (page: number) => void;
}

const TABLE_COLUMN_COUNT = 5;

export default function ModelHistoryTable(props: IModelHistoryTableProps) {
  const { data, page, size, isLoading, isError, onPageChange } = props;
  const historyRows = data?.result || [];
  const totalCount = data?.count || 0;

  return (
    <M.Box mt="lg">
      <M.Text fw={600} mb="sm">
        기계모델 설정 이력
      </M.Text>
      <M.Table.ScrollContainer minWidth={800}>
        <M.Table>
          <M.Table.Thead>
            <M.Table.Tr>
              <M.Table.Th>번호</M.Table.Th>
              <M.Table.Th>구분</M.Table.Th>
              <M.Table.Th>MachineGPT 적용 여부</M.Table.Th>
              <M.Table.Th>수정 담당자</M.Table.Th>
              <M.Table.Th>수정일시</M.Table.Th>
            </M.Table.Tr>
          </M.Table.Thead>
          <M.Table.Tbody>
            {isLoading ? (
              <M.Table.Tr>
                <M.Table.Td colSpan={TABLE_COLUMN_COUNT}>
                  <M.Flex justify="center" py="xl">
                    <M.Loader size="sm" />
                  </M.Flex>
                </M.Table.Td>
              </M.Table.Tr>
            ) : isError ? (
              <M.Table.Tr>
                <M.Table.Td colSpan={TABLE_COLUMN_COUNT}>
                  <M.Text ta="center" c="red.6" size="sm" py="xl">
                    기계모델 설정 이력을 불러오지 못했습니다.
                  </M.Text>
                </M.Table.Td>
              </M.Table.Tr>
            ) : historyRows.length > 0 ? (
              historyRows.map((item, index) => (
                <M.Table.Tr key={item.historyId}>
                  <M.Table.Td>{totalCount - ((page - 1) * size + index)}</M.Table.Td>
                  <M.Table.Td>{AI_AGENT_HISTORY_TYPE_LABELS[item.changeType] || item.changeType}</M.Table.Td>
                  <M.Table.Td>{item.afterUseYn === 'Y' ? '사용' : '미사용'}</M.Table.Td>
                  <M.Table.Td>{item.modifierEmail}</M.Table.Td>
                  <M.Table.Td>{handleChangeLocaleTime(item.modifiedAt)}</M.Table.Td>
                </M.Table.Tr>
              ))
            ) : (
              <M.Table.Tr>
                <M.Table.Td colSpan={TABLE_COLUMN_COUNT}>
                  <M.Text ta="center" c="gray.6" size="sm" py="xl">
                    조회된 이력이 없습니다.
                  </M.Text>
                </M.Table.Td>
              </M.Table.Tr>
            )}
          </M.Table.Tbody>
        </M.Table>
      </M.Table.ScrollContainer>
      {!isLoading && !isError && totalCount > 0 && (
        <M.Group justify="center" mt="md">
          <M.Pagination total={Math.ceil(totalCount / size)} value={page} onChange={onPageChange} />
        </M.Group>
      )}
    </M.Box>
  );
}
